import React, { useEffect } from 'react';
import { ReactComponent as IconMarker } from '../../assets/icons/icon-marker-orange.svg';
import ButtonOutlineGray from '../misc/ButtonOutlineGray';
import ButtonPrimary from '../misc/ButtonPrimary';
const ModalConfirmAddress = (props) => {
  // Overflow hidden
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => (document.body.style.overflow = 'unset');
  }, []);
  return (
    <div className="modal fixed w-full min-h-screen top-0 left-0 flex items-center justify-center z-20 overflow-hidden">
      <div className="modal-overlay absolute w-full h-full bg-gray-900 opacity-50 overflow-hidden"></div>
      <div className="modal-container bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto">
        <div className="modal-content items-center p-6 text-left">
          <div className="flex mb-4">
            <h4>Yakin Alamatnya Benar</h4>
            <button className="px-2 ml-auto" onClick={props.handdleCloseModal}>
              X
            </button>
          </div>
          <div className="flex border rounded-md border-gray-400 px-4 py-6 items-start">
            <span className="mr-4 flex">
              <IconMarker className="h-5 w-5" />
            </span>
            <p>
              Jl. Borobudur No.27A, Mojolangu, Kec. Lowokwaru, Kota Malang Jawa
              Timur 65142, Indonesia
            </p>
          </div>
          <div className="flex mt-6 justify-between -mx-2">
            <ButtonOutlineGray
              text="sm"
              handdleClick={props.handdleClickBack}
              addClass={'w-6/12 mx-2'}
            >
              Batal
            </ButtonOutlineGray>
            <ButtonPrimary
              handdleClick={props.handdleClickConfirm}
              text="sm"
              addClass={'w-6/12 mx-2'}
            >
              Konfirmasi
            </ButtonPrimary>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmAddress;
